module.exports = __webpack_public_path__ + "img/图层 774.f14c79a3.png";